function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Refresh"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M94.37 127.25a61.63 61.63 0 10-61.71-61.63v28.1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M62.12 65.47L32.66 93.72 4 65.47"
}));

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 131.25",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgRefresh;